import type { Href } from 'expo-router';

import type { EligibilityCheckResult } from '../types/eligibilityCheckResult';

import { shouldRouteToNotEligible } from './shouldRouteToNotEligible';

export function calculateCurrentRouteFromEligibilityCheckResult(
  eligibilityCheckResult?: EligibilityCheckResult
): Href {
  if (eligibilityCheckResult?.passed === true) {
    return '/step/eligible';
  }

  if (eligibilityCheckResult?.passed === false) {
    // Terminal / not-qualified failures (Sparta's NotEligible branch) get a
    // dedicated screen instead of looping on the employee-search retry.
    if (
      shouldRouteToNotEligible(
        eligibilityCheckResult.code,
        eligibilityCheckResult.eligibilityCheckFields
      )
    ) {
      return '/step/not-eligible';
    }

    return eligibilityCheckResult.supportsEligibilityCheck
      ? '/step/employee-search'
      : '/step/employer-or-health-plan-verification';
  }

  return '/step/company-search';
}
